import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { PopupComponent } from '../components/popup/popup.component';
import { ConsentRecordingComponent } from '../components/rec-permit/consent-recording.component';
import { TycComponent } from '../components/tyc/tyc.component';
import {
  ConsentRecordingBody,
  FinishPopupBody,
  lateMedic,
  networkMedicPopupBody,
  networkSocioPopupBody,
  PermissionsPopupBody,
  WaitMedicPopupBody,
  WaitSocioPopupBody,
} from '../constants/constants';

type ModalType =
  | 'waitM'
  | 'waitS'
  | 'finish'
  | 'permissions'
  | 'netM'
  | 'netS'
  | 'tycs'
  | 'consentR'
  | 'lateM';
type DialogType = MatDialogRef<
  PopupComponent | TycComponent | ConsentRecordingComponent
>;

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  dialog: DialogType;

  constructor(private _matDialog: MatDialog) {}

  createDialog(type: ModalType, cid?: number, isMedic?: number): DialogType {
    let body = {};

    if (type === 'tycs') {
      this.dialog = this._matDialog.open(TycComponent, {
        panelClass: 'backgroundPopup',
      });
      return this.dialog;
    }

    const popupConfig = {
      width: '100%',
      height: '100%',
      data: {
        cid,
        isMedic,
      },
      panelClass: 'backgroundPopup',
      hasBackdrop: true,
    };

    switch (type) {
      case 'waitM':
        body = WaitMedicPopupBody;
        break;
      case 'waitS':
        body = WaitSocioPopupBody;
        break;
      case 'finish':
        body = FinishPopupBody;
        break;
      case 'permissions':
        body = PermissionsPopupBody;
        break;
      case 'netM':
        body = networkMedicPopupBody;
        break;
      case 'netS':
        body = networkSocioPopupBody;
        break;
      case 'consentR':
        body = ConsentRecordingBody;
        break;
      case 'lateM':
        body = lateMedic;
        break;
    }

    popupConfig.data = { ...body, ...popupConfig.data };

    if (type === 'consentR') {
      this.dialog = this._matDialog.open(
        ConsentRecordingComponent,
        popupConfig
      );

      return this.dialog;
    }

    this.dialog = this._matDialog.open(PopupComponent, popupConfig)

    return this.dialog;
  }

  closeDialog(): void {
    this.dialog.close();
  }
}
